import { useStore } from "@nanostores/react"
import { createWebPersistentMap } from "./persistent"

export interface UtmParams {
  utmCampaign?: string | null
  utmContent?: string | null
  utmMedium?: string | null
  utmSource?: string | null
  utmTerm?: string | null
}

export const $utm = createWebPersistentMap<UtmParams>("utm:", {})

export const getUtm = (): UtmParams => {
  const utm = $utm.get()
  return {
    utmCampaign: utm.utmCampaign,
    utmContent: utm.utmContent,
    utmMedium: utm.utmMedium,
    utmSource: utm.utmSource,
    utmTerm: utm.utmTerm,
  }
}

export const useUtmStore = () => {
  const $utmStore = useStore($utm)
  return {
    utmCampaign: $utmStore.utmCampaign,
    utmContent: $utmStore.utmContent,
    utmMedium: $utmStore.utmMedium,
    utmSource: $utmStore.utmSource,
    utmTerm: $utmStore.utmTerm,
  }
}

export const updateUtm = (utm: UtmParams) => {
  $utm.set({
    utmCampaign: utm.utmCampaign ?? null,
    utmContent: utm.utmContent ?? null,
    utmMedium: utm.utmMedium ?? null,
    utmSource: utm.utmSource ?? null,
    utmTerm: utm.utmTerm ?? null,
  })
}

export const resetUtm = () => {
  $utm.set({
    utmCampaign: null,
    utmContent: null,
    utmMedium: null,
    utmSource: null,
    utmTerm: null,
  })
}
